/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFilePptx = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586v3.44h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="M9.955 13.041c.482 0 .845.111 1.09.334.248.223.372.554.372.993 0 .291-.056.536-.167.734a1.037 1.037 0 0 1-.491.442c-.216.1-.484.151-.804.151H9.39v1.268h-.837V13.04zM9.39 15.01h.393c.288 0 .49-.049.61-.146.122-.1.183-.266.183-.496 0-.234-.061-.4-.183-.497-.12-.097-.322-.145-.61-.145H9.39zm3.947-1.969c.482 0 .845.111 1.09.334.248.223.373.554.373.993 0 .291-.057.536-.168.734a1.036 1.036 0 0 1-.49.442c-.216.1-.485.151-.805.151h-.566v1.268h-.836V13.04zm-.566 1.969h.394c.288 0 .49-.049.61-.146.122-.1.183-.266.183-.496 0-.234-.061-.4-.184-.497-.118-.097-.321-.145-.609-.145h-.394zm5.449-1.257h-1.16v3.21h-.84v-3.21h-1.16v-.712h3.16zm2.063.643.788-1.355H22l-1.154 1.901 1.214 2.02h-.966l-.875-1.483-.841 1.484h-.928l1.21-2.035-1.15-1.887h.966z" />
      </g>
    </g>
  </Icon>
);
export { SvgFilePptx as FilePptx };
